module.exports = __webpack_public_path__ + "images/mourikd6ae92ee24a760420c4aaf93bc09f3ba.png";